"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function DataprotectionofficerBlueMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__dataprotectionofficer-blue-multitone-filled__clip0_13467_204)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    d: "M8.136.012s3.586 1.877 6.522 1.638v7.91c0 .98-.331 1.931-.939 2.7-.874 1.114-2.671 2.592-5.587 3.74-2.917-1.148-4.72-2.626-5.588-3.74a4.34 4.34 0 01-.944-2.7V1.65C4.551 1.89 8.136.012 8.136.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M8.138 1.129a16.503 16.503 0 005.523 1.527v6.901c0 .758-.255 1.493-.724 2.088-.46.579-1.818 2.027-4.804 3.275-2.996-1.248-4.349-2.696-4.803-3.275a3.37 3.37 0 01-.73-2.088v-6.9a16.223 16.223 0 005.538-1.528zm0-1.109s-3.17 1.648-5.992 1.648h-.534v7.89c0 .98.333 1.933.944 2.7.868 1.114 2.671 2.592 5.587 3.74 2.916-1.148 4.714-2.626 5.588-3.74.604-.77.93-1.721.929-2.7v-7.91h-.53C11.304 1.648 8.138 0 8.138 0v.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    fillRule: "evenodd",
    d: "M8.166 4.005a.899.899 0 100 1.797.899.899 0 000-1.797zm2.497 3.994A1.773 1.773 0 009.625 7.5L8.166 9.158 6.728 7.5A1.778 1.778 0 005.17 9.273v.724h5.992v-.724a1.757 1.757 0 00-.499-1.274z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M11.347 7.31a2.765 2.765 0 00-1.957-.808h-.2a1.897 1.897 0 10-2.022 0h-.2a2.761 2.761 0 00-2.796 2.77v1.724h7.99V9.273a2.762 2.762 0 00-.815-1.963zm-.184 2.687H5.17v-.724A1.778 1.778 0 016.729 7.5l1.438 1.658L9.605 7.5a1.778 1.778 0 011.558 1.773v.724zM8.167 4.005a.899.899 0 110 1.798.899.899 0 010-1.798zm.963 2.532L8.167 7.64l-.97-1.103a1.997 1.997 0 001.933 0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__dataprotectionofficer-blue-multitone-filled__clip0_13467_204"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

DataprotectionofficerBlueMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
DataprotectionofficerBlueMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = DataprotectionofficerBlueMultitoneFilled;
exports["default"] = _default;